import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox, FormControlLabel } from '@mui/material';

import KogInputAmountControlled from '@/main/components/shared/inputText/inputAmountControlled';
import { getTranslateByKey } from '@/main/services/utils';

import * as S from './styles';

interface IInputTextPriceListProps {
  idScreen: string;
  nameInput: string;
  nameCheckbox: string;
  label: string;
}
function InputTextPriceList({
  idScreen,
  nameCheckbox,
  nameInput,
  label
}: IInputTextPriceListProps) {

  const { control, setValue, clearErrors, watch } = useFormContext();

  const watcherNoCheckbox = watch(nameCheckbox);
  const generateId = (id: string) => `${idScreen}-${id}`;

  return (
    <S.Container>
      <KogInputAmountControlled
        required={!watcherNoCheckbox}
        name={nameInput}
        id={generateId(nameInput)}
        typeInput='filled'
        label={label}
        hideValue={watcherNoCheckbox}
        control={control}
        customInputProps={{
          disabled: watcherNoCheckbox
        }}
      />
      <Controller
        name={nameCheckbox}
        control={control}
        render={({ field: { onChange, value } }) => (
          <S.AreaCheckbox $isChecked={watcherNoCheckbox}>
            <FormControlLabel
              label={getTranslateByKey('importInventory.noPrice')}
              control={
                <Checkbox
                  id={generateId(nameCheckbox)}
                  color="primary"
                  checked={value}
                  onChange={e => {
                    onChange(e.target.checked);
                    if (e.target.checked) {
                      clearErrors(nameInput);
                      setValue(nameInput, '');
                    }
                  }}
                />
              }
            />
          </S.AreaCheckbox>
        )}
      />
    </S.Container>
  )
}

export default InputTextPriceList